import React, { useState } from "react";
import { useField } from "formik";

import styles from "../../assets/css/components/Input/Input.module.css";
import classnames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const InputPass = ({ title, placeholder, ...props }) => {
  const [field, meta] = useField(props);

  const [pass, setPass] = useState(false);

  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <div className={classnames(styles.input, styles.contInput)}>
        <input
          {...field}
          {...props}
          className={styles.inputPass}
          type={pass ? "text" : "password"}
          placeholder={placeholder ? placeholder : "Escribir"}
        />
        <button
          type="button"
          className={
            pass ? classnames(styles.btn, styles.btnActive) : styles.btn
          }
          onClick={() => setPass(!pass)}
        >
          {pass ? (
            <FontAwesomeIcon icon={faEye} />
          ) : (
            <FontAwesomeIcon icon={faEyeSlash} />
          )}
        </button>
      </div>
      {meta.touched && meta.error && (
        <p className={styles.txtWarning}>{meta.error}</p>
      )}
    </div>
  );
};

export default InputPass;
